export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (_e) => resolve(reader.result as string);
    reader.onerror = (_e) => reject(new Error(JSON.stringify(reader.error)));
    reader.onabort = (_e) => reject(new Error('Read aborted'));
    reader.readAsDataURL(blob);
  });
}

export function clearLocalStorage() {
  clearStorage(globalThis.localStorage);
}

export function clearSessionStorage() {
  clearStorage(globalThis.sessionStorage);
}

function clearStorage(storage: Storage) {
  storage.clear();
}

export function isRunningInUnitTest(): boolean {
  return process.env.NODE_ENV === 'test';
}

export function noop<A = void, R = void>(_arg: A): R {
  return null as unknown as R;
}

export function noopFn<A = void, R = void>(): (arg: A) => R {
  return noop;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noArgNoop(): void {}

export function range(start: number, stop: number, step = 1): number[] {
  return Array.from({length: (stop - start) / step + 1}, (_, i) => start + i * step);
}

export function sleep(delayMillis: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, delayMillis));
}
